module.exports = __webpack_public_path__ + "static/img/2015.d4ad07e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2015.png
// module id = RPLz
// module chunks = 0